import { create } from 'zustand';

import { CreatePostMarketStep } from 'constants/social';
import type { GifAttachmentDraft } from 'utils/socialMediaAttachments';

export interface MarketBuilderDraft {
    title: string;
    case: string;
    settlementSource: string;
    /** ISO date (yyyy-MM-dd) from a `<input type="date">`. */
    closeDate: string;
    gif: GifAttachmentDraft | null;
}

const EMPTY_DRAFT: MarketBuilderDraft = {
    title: '',
    case: '',
    settlementSource: '',
    closeDate: '',
    gif: null,
};

interface MarketBuilderActions {
    open: () => void;
    close: () => void;
    setStep: (step: CreatePostMarketStep) => void;
    setDraftField: <K extends keyof MarketBuilderDraft>(key: K, value: MarketBuilderDraft[K]) => void;
    resetDraft: () => void;
}

interface MarketBuilderState {
    isOpen: boolean;
    step: CreatePostMarketStep;
    draft: MarketBuilderDraft;
    actions: MarketBuilderActions;
}

export const useMarketBuilderStore = create<MarketBuilderState>()((set) => ({
    isOpen: false,
    step: CreatePostMarketStep.TITLE,
    draft: EMPTY_DRAFT,

    actions: {
        open: () => set({ isOpen: true, step: CreatePostMarketStep.TITLE }),
        close: () => set({ isOpen: false, step: CreatePostMarketStep.TITLE }),
        setStep: (step) => set({ step }),
        setDraftField: (key, value) =>
            set((state) => ({
                draft: { ...state.draft, [key]: value },
            })),
        resetDraft: () => set({ draft: EMPTY_DRAFT, step: CreatePostMarketStep.TITLE }),
    },
}));
